//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vuexMixin from "@/lib/vuexMixin"

export default {
  name: "layoutError",
  mixins: [ vuexMixin ],
  computed:{
    head () {
        return this.error.statusCode === 404 ? this.pageNotFound : this.otherError
      
    }
  },
  data () {
    return {
      error: {statusCode: 101},
      pageNotFound: 'Oooooooops! Você tentou acessar uma página que não existe!',
      otherError: ' Oooooooops! Falha no processamento!',
    }
  },
}
